import React, { Component } from "react"

import ClinicianBanner from "src/components/Shared/ClinicianBanner/ClinicianBanner.js"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import Zoom from "@material-ui/core/Zoom"

import "./ContactUs.css"

export default class ContactUs extends Component {
  state = {
    name: "",
    email: "",
    message: "",
    messageElement: (
      <div className="contact-success">
        Thank you for contacting us. A Graston Associate with reach out to you
        soon!
      </div>
    ),
    messageSent: false,
  }

  handleChange = e => {
    const { name, value } = e.target

    this.setState({
      [name]: value,
    })
  }

  submitContactRequest = async () => {
    const { name, email, message } = this.state

    const contactResponse = await fetch(
      process.env.GATSBY_CONTACT_US_ENDPOINT,
      {
        body: JSON.stringify({
          EmailAddress: email,
          Name: name,
          Message: message,
        }),
        method: "POST",
      }
    )

    const contactResults = await contactResponse.json()

    if (contactResults === "Accepted") {
      this.setState({
        name: "",
        email: "",
        message: "",
        messageSent: true,
      })
    }
  }

  render() {
    const { name, email, message, messageElement, messageSent } = this.state

    return (
      <Grid container direction="row-reverse" className="contact-us">
        <Grid item xs={12}>
          <ClinicianBanner extraClass="unlogged-training-image-long" />
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container justify="center">
            <Grid item xs={11} md={10}>
              <Paper className="contact-us-wrapper">
                <Typography
                  variant="h4"
                  align="center"
                  className="contact-us-header"
                >
                  Say Hello
                </Typography>

                <Zoom in={messageSent}>{messageElement}</Zoom>

                <Grid container justify="center">
                  <Grid item xs={10} md={7} className="contact-us-field">
                    <TextField
                      label="Your Name"
                      fullWidth
                      name="name"
                      value={name}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={10} md={7} className="contact-us-field">
                    <TextField
                      label="Your Email"
                      fullWidth
                      name="email"
                      value={email}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={10} md={7} className="contact-us-field">
                    <TextField
                      label="Your Message"
                      rows="4"
                      multiline
                      fullWidth
                      name="message"
                      value={message}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={10} md={7} className="contact-us-submit">
                    <button onClick={this.submitContactRequest}>Submit</button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container justify="center">
            <Grid item xs={11} md={7}>
              <Typography
                variant="h4"
                align="left"
                className="get-in-touch-header"
              >
                Get in Touch
              </Typography>
              <Typography variant="body1" className="get-in-touch-body">
                <b>For general inquiries, please contact GT HQ at:</b>
              </Typography>

              <Typography variant="body1" className="get-in-touch-body">
                7801 E 88th St <br />
                Indianapolis, IN 46256
              </Typography>

              <Typography variant="body1" className="get-in-touch-body">
                Phone: 888.926.2727 or 317.926.2996
              </Typography>

              <Typography variant="body1" className="get-in-touch-body">
                Business Hours: Monday - Friday <br />
                8:00 AM - 5:00 PM EST
              </Typography>

              <Typography variant="body1" className="get-in-touch-body">
                Please Note: It is our company policy that we do not give medical advice to any individual. General information will be provided about the indications and benefits of GT.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
